module.exports = __webpack_public_path__ + "img/speaker-1-2.f675cee6.jpg";